
import { contentTypeList, acceptList } from '../util/wj.config';
import commonTools from '../util/tools';
/**
 * 
 * @param data 
 * 截取DEVICE_ 返回数字
 */
export function doString(data) {
  return data.replace("DEVICE_", "");
}


/**
 * 
 * @param contentType
 * 特定的请求头  直接返回data
 */
export function doHeader(contentType) {
  let typeBoolean = false;
  if (contentTypeList.indexOf(contentType) > -1) {
    typeBoolean = true;
  }
  return typeBoolean;
}


/**
 * 接受后台返回的格式
 */
export function doHeaderAccept() {
  let result = '';
  result = acceptList.join(', ');
  return result;
}

/**
 * 表格操作的，分页支持
 */
export class DataParse {
  constructor() {
    this.listItem = [];
    this.total = 0;
  }
  getNo(pageNum, pageSize) {
    const startPage = (pageNum - 1) * pageSize;
    const length = this.listItem.length;
    for (let i = 0; i < length; i++) {
      this.listItem[i]['no'] = startPage + i + 1;
    }
  }
}

// 获取url后面的参数
export function getUrlParams(url) {
  // 获取? 后面第一个字符的索引
  const index = url.indexOf('?') + 1;
  // url中?后面的字符串 name=zs&age=18&a=1&b=2
  let params = url.substr(index);
  // 使用& 切割字符串 ，返回一个数组
  let arr = params.split('&');
  let o = {};
  // 数组中每一项的样子 key = value
  for (let i = 0; i < arr.length; i++) {
    let tmpArr = arr[i].split('=');
    let key = tmpArr[0];
    let value = tmpArr[1];
    o[key] = value;
  }
  return o;
}

/**
 * @param list 数组 ['111','222','333','444']或者[{a:'a',b:'b',c:'c'}]
 * @param headerList [label: '11', value: '22']
      [{a:'a',b:'b'}] 需要带headerList，里面放的是label 和value要取的值。
 * 
 * */
export function getSelectOption(list, headerList = {}) {
  let result = [], arrayType = commonTools.checkArrayType(list);
  if (!arrayType) commonTools.error('list type error !');
  const listLength = list.length, headerLength = Object.keys(headerList).length;
  if (listLength == 0) return result
  if (arrayType.type == 'object') {
    if(headerList instanceof Array) commonTools.error('headerList type error ! ')
    if(headerLength == 0) commonTools.error('headerList could not be null ! ');
    const label = headerList.label, value = headerList.value;
    for(let item of list) {
      result.push({ label: item[`${label}`], value: item[`${value}`]})
    }
  } else {
    for (let item of list) {
      result.push({ label: item, value: item });
    }
  }
  return result
}

export const serverName = {
  feather_portal: "/feather-portal",
  feather_quartz: "/feather-quartz",
  feather_hr: '/feather-hr',
  feather_device: '/feather-device',
  feather_selfservice: '/feather-selfservice',
  feather_class: '/feather-class',
  feather_oa: '/feather-oa',
  feather_doc: '/feather-doc',
  feather_legal: '/feather-legal',
  feather_sale: '/feather-sale',
  feather_flowable: 'feather-flowable',
  feather_xfmweb: '/feather-xfmweb',
  feather_security: "/feather-security",
  snms_portal: "/snms-portal",
  snms_web: '/snms-web',
}
